import { Observable } from 'rxjs';

import { map } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import {
  ChainType,
  ClaimConnexConfig,
  FileType,
  GroupCriteria,
  MatchType,
  SearchCriteria,
} from '@models/file/model';
import { Uri } from '@app/shared/utils/uri';
import { FileProcessConfigViewModel } from '@clux-models';
import { CoreService } from '@app/shared/models/clux/enum';

@Injectable()
export class FileProcessConfigService {
  private http = inject(HttpClient);

  /**
   * Get FileProcessConfigViewModel for each filetype for the client
   * @param {string} clientId
   * @returns {Observable<Map<FileType, FileProcessConfigViewModel>>}
   * @memberof FileProcessConfigService
   */
  public getFileProcessConfigs(clientId: string, extraCriteria?: GroupCriteria[]): Observable<Map<FileType, FileProcessConfigViewModel>> {
    const fileProcessConfigs = new Map<FileType, FileProcessConfigViewModel>();

    const searchUrl = new Uri(`/profile/${clientId}/fileProcessConfig/search`, CoreService.File, {});
    const criteria: SearchCriteria = [
      {
        key: 'parentType',
        value: 'INSTANCE',
        matchType: MatchType.EXACT,
        chainType: ChainType.OR,
      },
      {
        key: 'parentId',
        value: clientId,
        matchType: MatchType.EXACT,
      },
    ];

    if (extraCriteria && extraCriteria.length > 0) {
      criteria[1].chainType = ChainType.AND;
      criteria[1].groupCriteria = extraCriteria;
    }

    return this.http.post<FileProcessConfigViewModel[]>(searchUrl.toString(), criteria).pipe(
      map((fileSettings) => {
        // set current values for file config
        fileSettings.forEach((fileSetting) => {
          if (fileSetting.parentType === 'CLIENT') {
            if (fileSetting.fileType === FileType.ClaimConnex && fileSetting.config && fileSetting.config.claimConnex) {
              fileSetting.config.claimConnex = this.mapClaimConnexConfigFields(fileSetting.config.claimConnex);
            }
            fileProcessConfigs.set(fileSetting.fileType, fileSetting);
          }
        });
        return fileProcessConfigs;
      })
    );
  }

  private mapClaimConnexConfigFields(config: ClaimConnexConfig): ClaimConnexConfig {
    if (config.carrierConfigs && config.carrierConfigs.length > 0) {
      config.carrierConfigs = config.carrierConfigs.map((carrier) => {
        if (!carrier.groupIds || carrier.groupIds.length === 0) {
          carrier.groupIds = [carrier.clientCarrierEin];
        }
        return carrier;
      });
    }
    return config;
  }
}
